import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Using the Context",
description: "Connect all interpreter pieces using the evaluation context. Learn how to compute the number of correct answers, obtain a grade for a page, follow flow rules, and return the next page for each Step.",
tags: [ "Freon", "interpreter", "context", "InterpreterContext", "Step", "Page", "Flow", "FlowRule", "PageTransition", "grading", "NrOfCorrectAnswers", "QuestionReference", "RtGrade", "RtFlow", "RtPage", "runtime", "evaluation"] ,
modifiedTime: "2025-11-07T17:20:18.626Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};